
<template>
    <div
        class="customer-panel"
        :style="{height}"
    >
        <div class="customer-panel-header">
            <div
                v-for="v in tabs"
                :key="v.key"
                :class="{'customer-panel-header-item':true,current:c_current === v.key}"
                @click="()=>current = v.key"
            >
                {{v.title}}
            </div>
        </div>
        <div class="customer-panel-body">
            <slot :current="c_current"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        height: { default: "auto" },
        tabs: {
            default: () => [
                { title: "工单", key: "worksheet" },
                { title: "问答", key: "question" },
            ],
        },
    },

    data: () => ({
        current: "",
    }),

    computed: {
        c_current() {
            if (this.current) return this.current;
            if (this.tabs[0]) return this.tabs[0].key;
            return "";
        },
    },
};
</script>

<style scoped>
.customer-panel {
    
    background: #fff;
    height: 480px;
    width: 320px;
    padding: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.customer-panel-header {
    height: 40px;
    flex: 0;
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
    justify-content: space-between;
}

.customer-panel-header-item {
    height: 40px;
    line-height: 40px;
    width: 148px;
    text-align: center;
    cursor: pointer;
    transition: 0.6s all ease-out;

    font-size: var(--font-size-large);
    color: var(--text-color-content);
}

.customer-panel-header-item:hover {
    color: var(--action-color);
}

.customer-panel-header-item.current {
    background: var(--action-color-light);
    color: var(--action-color);
    font-weight: var(--font-weight-bolder);
}
.customer-panel-body {
    flex: auto;
    overflow: hidden;
}


</style>